var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistanceWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#DE2C3C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.707 8v6h.986V2h-.986v6M13.2 5.1l.001 3.1.259.12c.143.066.35.18.46.253l.233.155c.027.017.034-.66.034-3.353V2H13.2v3.1M4.173 6.827 3 8l1.173 1.173 1.173 1.173.354-.352.353-.353-.566-.567-.567-.567h5.241l.246-.124c.286-.144.594-.253.906-.32.279-.061 1.035-.068 1.309-.013.165.033.187.033.226-.007.041-.041-.04-.128-1.128-1.217l-1.173-1.173L10.2 6l-.346.347.573.573.573.573H4.92l.567-.567.566-.567-.353-.353-.354-.352-1.173 1.173m7.363 1.721c-1.296.245-2.263 1.216-2.485 2.495-.063.361-.041.908.05 1.255a3.068 3.068 0 0 0 2.201 2.203c.236.064.301.07.751.069.449 0 .517-.007.757-.071a3.046 3.046 0 0 0 2.275-3.072c-.059-1.381-.988-2.506-2.345-2.842-.298-.074-.911-.093-1.204-.037M12.347 11v1.507h-.694V9.493h.694V11m-.129 2.056a.456.456 0 0 1 .176.608c-.099.17-.183.216-.394.216-.212 0-.296-.046-.393-.216-.221-.386.21-.816.611-.608",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceWarning);
export default __webpack_public_path__ + "static/media/distance-warning.eed3fa1b53f1c3f337a7e1193c6c2e57.svg";
export { ForwardRef as ReactComponent };